<template>
    <div>
        <a-row class="flex">
            <div class="flex items-center">
                
                <a-button size="small" class="ml10 mb10" v-if="user.can_add"   @click="addSupplier()">新增供应商</a-button>
                <!-- <a-button size="small" class="ml10 mb10" v-if="request_body.role == 35 || request_body.role == 16 || request_body.role == 1 ||request_body.role == 15 || request_body.role == 18"   @click="addSupplier()">新增供应商</a-button> -->
                
                <a-input size="small" allowClear class="mb10 ml10" v-model="search" placeholder="请输入物资名称/供应商名称/备注" style="width: 300px" enter-button @change="allowSupplierClear" @pressEnter="onSearch" />
            </div>
            <a-button size="small" class="ml10" type="primary" icon="search" @click="onSearch">
                查询
            </a-button>
            <a-button size="small" class="ml10" type="primary" icon="sync" @click="reset">
                复位
            </a-button>
        </a-row>
        
        <a-row :gutter="24" type="flex" align="stretch">
            <!-- Table -->
            <a-col :span="24" :lg="30" class="mb-24">
                <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{padding: 0,}">
                    <a-table :data-source="data" :columns="columns" class="pd15 w100"  :pagination="false"  size="small" bordered >
                        <span slot="operation" slot-scope="text, record">
                            <a @click="goDetail(record.id)">详情</a>
                        </span>
                    </a-table>
                    <a-pagination 
                        class="flex items-center mb10"
                        style="justify-content: flex-end"
                        show-quick-jumper  
                        v-model="page.page" 
                        :total="page.total" 
                        :page-size="30"
                        @change="onShowSizeChange" 
                    />
                </a-card>
                
            </a-col>
        
        </a-row>
        <a-drawer
            title="新增供应商"
            :width="720"
            :visible="dialogVisible"
            :body-style="{ paddingBottom: '80px' }"
            @close="dialogVisible=false"
        >
            <div>
                <CardAddSupplier @update-param="updateParam" :suppliers="suppliers"></CardAddSupplier>
            </div>
        </a-drawer>
    </div>
</template>
<script>
import CardAddSupplier from '../../components/Cards/CardAddSupplier.vue';
import request_body from "/src/utils/request_body.js";

    export default {
        components: { 
            CardAddSupplier

        },
        data() {
            return {
                request_body,
                data:[],
                searchText: '',
                searchInput: null,
                searchedColumn: '',
                columns: [
                    {
                        title: '供应商',
                        dataIndex: 'name',
                        key: 'name',
                        width: '20%',
                    },
                    {
                        title: '区域',
                        dataIndex: 'area',
                        key: 'area',
                       
                        width: '25%',

                    },
                    {
                        title: '简介',
                        dataIndex: 'introduction',
                        key: 'introduction',
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        key: 'operation',
                        // scopedSlots: { customRender: 'operation' },
                        scopedSlots: { customRender: 'operation' },
                    }
                ],
                page:{
                    page:1,
                    total:0
                },
                search:"",
                dialogVisible:false,
                suppliers:[],
                user:{
                    can_add:false,
                }
            }
        },
        created(){
            this.getSuppliersList()
            this.getSuppliersNameList()
        },
        methods:{
            handleSearch(selectedKeys, confirm, dataIndex) {
                confirm();
                this.searchText = selectedKeys[0];
                this.searchedColumn = dataIndex;
            },
            handleReset(clearFilters) {
                clearFilters();
                this.searchText = '';
            },
            async getSuppliersList(){
                let rs = await this.$api.goSearchSupplier(this.search, this.page.page - 1, 30)
                // console.log(rs)
                if(rs.err == 0){
                    this.page.total = rs.count
                    this.data = rs.data
                    for(var i = 0; i < this.data.length;i++){
                        this.data[i].key = i + 1;
                    }
                    if(rs.can_add != undefined){
                        this.user.can_add  =rs.can_add
                    }
                }
            },
            async getSuppliersNameList(){
                let rs = await this.$api.getSuppliersNameList()
                // console.log(rs.data)
                if(rs.err == 0){
                    for(var i = 0; i < rs.data.length;i++){
                        rs.data[i].key = i + 1;
                    }
                    this.suppliers = rs.data
                }
            },
            async onSearch(){
                if(this.search.length == 0){
                    this.$notification['warning']({
                        message: '查询条件为空',
                        description:
                        '请选择供应商名称进行查询',
                        style: {
                            width: '600px',
                            marginLeft: `${335 - 600}px`,
                        },
                    });
                    return;
                } else {
                    let rs = await this.$api.goSearchSupplier(this.search, this.page.page - 1,30)
                    if(rs.err == 0){
                        this.data = rs.data
                        for(var i = 0; i < this.data.length;i++){
                            this.data[i].key = i + 1;
                        }
                        this.page.page = 1
                        this.page.total = rs.count
                    }
                }
            },
            reset(){
                this.page.page = 1
                this.search = ""
                this.getSuppliersList()
            },
            addSupplier(){
                this.dialogVisible = true
            },
            onShowSizeChange() {
                if(this.search.length != 0){
                    this.onSearch()
                }else{
                    this.getSuppliersList()
                }
            },
            allowSupplierClear(){
                if(this.search.length == 0){
                    this.page.page = 1
                    this.getSuppliersList()
                }
            },
            updateParam(newParam){
                if(newParam.key == 1){ //更新审批信息
                    this.dialogVisible = false
                    this.getSuppliersList()
                }
            },
            goDetail(id){
                this.$router.push(`/purchase/suppliers/detail?supplier_id=${id}`)
            }
        }
    }

</script>

<style scoped>
.highlight {
  background-color: rgb(255, 192, 105);
  padding: 0px;
}
</style>
